/**
 * EB 主题预设 CSS 变量（对齐 view/mer layout/navBars/breadcrumb/theme.js）
 */
export const CRMEB_THEME_PRESETS: Record<string, Record<string, string>> = {
  'theme-1': {
    '--prev-bg-menuBar': '#282c34',
    '--prev-bg-menuBarColor': '#fff',
    '--prev-color-primary': '#4073FA',
    '--prev-bg-menu-hover-ba-color': '#4073FA',
    '--prev-bg-topBar': '#fff',
    '--prev-bg-topBarColor': '#282c34',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#4073FA',
    '--prev-tag-active-color': '#4073FA',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-2': {
    '--prev-bg-menuBar': '#ffffff',
    '--prev-bg-menuBarColor': '#515a6e',
    '--prev-color-primary': '#4073FA',
    '--prev-bg-menu-hover-ba-color': '#e8f4ff',
    '--prev-bg-topBar': '#ffffff',
    '--prev-bg-topBarColor': '#515a6e',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#4073FA',
    '--prev-tag-active-color': '#4073FA',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-3': {
    '--prev-bg-menuBar': '#282c34',
    '--prev-bg-menuBarColor': '#fff',
    '--prev-color-primary': '#41b584',
    '--prev-bg-menu-hover-ba-color': '#41b584',
    '--prev-bg-topBar': '#fff',
    '--prev-bg-topBarColor': '#282c34',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#41b584',
    '--prev-tag-active-color': '#41b584',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-4': {
    '--prev-bg-menuBar': '#ffffff',
    '--prev-bg-menuBarColor': '#515a6e',
    '--prev-color-primary': '#41b584',
    '--prev-bg-menu-hover-ba-color': '#ecf8f3',
    '--prev-bg-topBar': '#ffffff',
    '--prev-bg-topBarColor': '#515a6e',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#41b584',
    '--prev-tag-active-color': '#41b584',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-5': {
    '--prev-bg-menuBar': '#282c34',
    '--prev-bg-menuBarColor': '#fff',
    '--prev-color-primary': '#6954f0',
    '--prev-bg-menu-hover-ba-color': '#6954f0',
    '--prev-bg-topBar': '#fff',
    '--prev-bg-topBarColor': '#282c34',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#6954f0',
    '--prev-tag-active-color': '#6954f0',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-6': {
    '--prev-bg-menuBar': '#ffffff',
    '--prev-bg-menuBarColor': '#515a6e',
    '--prev-color-primary': '#6954f0',
    '--prev-bg-menu-hover-ba-color': '#f0eefe',
    '--prev-bg-topBar': '#ffffff',
    '--prev-bg-topBarColor': '#515a6e',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#6954f0',
    '--prev-tag-active-color': '#6954f0',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-7': {
    '--prev-bg-menuBar': '#282c34',
    '--prev-bg-menuBarColor': '#fff',
    '--prev-color-primary': '#f34d37',
    '--prev-bg-menu-hover-ba-color': '#f34d37',
    '--prev-bg-topBar': '#fff',
    '--prev-bg-topBarColor': '#282c34',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#f34d37',
    '--prev-tag-active-color': '#f34d37',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-8': {
    '--prev-bg-menuBar': '#ffffff',
    '--prev-bg-menuBarColor': '#515a6e',
    '--prev-color-primary': '#f34d37',
    '--prev-bg-menu-hover-ba-color': '#feedeb',
    '--prev-bg-topBar': '#ffffff',
    '--prev-bg-topBarColor': '#515a6e',
    '--prev-bg-columnsMenuBar': '#282c34',
    '--prev-bg-columnsMenuBarColor': '#e6e6e6',
    '--prev-MenuActiveColor': '#f34d37',
    '--prev-tag-active-color': '#f34d37',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
  'theme-9': {
    '--prev-bg-menuBar': '#ffffff',
    '--prev-bg-menuBarColor': '#303133',
    '--prev-color-primary': '#4073FA',
    '--prev-bg-menu-hover-ba-color': '#e8f4ff',
    '--prev-bg-topBar': '#ffffff',
    '--prev-bg-topBarColor': '#515a6e',
    '--prev-bg-columnsMenuBar': 'linear-gradient(90deg,#006cff,#399efd)',
    '--prev-bg-columnsMenuBarColor': '#fff',
    '--prev-MenuActiveColor': '#4073FA',
    '--prev-tag-active-color': '#4073FA',
    '--prev-bg-columnsMenuActiveColor': '#fff',
  },
};

export const THEME_PRIMARY_MAP: Record<string, string> = {
  'theme-1': '#4073FA',
  'theme-2': '#4073FA',
  'theme-3': '#41b584',
  'theme-4': '#41b584',
  'theme-5': '#6954f0',
  'theme-6': '#6954f0',
  'theme-7': '#f34d37',
  'theme-8': '#f34d37',
  'theme-9': '#4073FA',
};
